"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shouldOpenForCurrentUrlPathname = void 0;
const ALLOWED_PATHNAME_REGEXES = [/^(\/[a-z]{2})?\/?$/i, /^(\/[a-z]{2})?\/skincare(\/.*?)?$/i, /^(\/[a-z]{2})?\/brands\/novage(\/.*?)?$/i, /^(\/[a-z]{2})?\/brands\/novage-plus(\/.*?)?$/i];
const shouldOpenForCurrentUrlPathname = () => ALLOWED_PATHNAME_REGEXES.some(regex => regex.test(window.location.pathname));
exports.shouldOpenForCurrentUrlPathname = shouldOpenForCurrentUrlPathname;